import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import NotAuthorized from '../pages/NotAuthorized';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { user, isPathAllowed, isMenuLoading, allowedPaths } = useAuth();

  // User not authenticated — redirect to login
  if (!user?.nip) {
    return <Navigate to="/login" replace />;
  }

  if (isMenuLoading && allowedPaths.size === 0) {
    return (
      <div className="flex min-h-[calc(100vh-70px)] items-center justify-center bg-[#F4F7FE]">
        <Loader2 className="h-10 w-10 animate-spin text-brand-500" aria-label="Loading" />
      </div>
    );
  }

  if (!isPathAllowed(location.pathname)) {
    return <NotAuthorized />;
  }

  return children;
};

export default ProtectedRoute;
